module.exports = __webpack_public_path__ + "static/media/logo512.d39b5022.png";